// Snow Lite — base JS

// Accessibility: ensure all iframe/frame elements have an accessible name
(function () {
  function labelFrames(root) {
    root.querySelectorAll('iframe:not([title]), frame:not([title])').forEach(function (frame) {
      var src = frame.getAttribute('src') || '';
      var label = 'Embedded content';
      if (/youtube/i.test(src)) label = 'YouTube video';
      else if (/vimeo/i.test(src)) label = 'Vimeo video';
      else if (/ketch/i.test(src)) label = 'Privacy preferences';
      else if (/klaviyo/i.test(src)) label = 'Email signup form';
      frame.setAttribute('title', label);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { labelFrames(document); });
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.tagName === 'IFRAME' || node.tagName === 'FRAME') labelFrames(node.parentElement || document);
          else labelFrames(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

// Ketch preferences link — replace escaped HTML nav item with live link + remove empty wrapper
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a').forEach(function (el) {
    if (el.textContent.indexOf('Your privacy choices') !== -1 && el.innerHTML.indexOf('preferenceCenterLink') !== -1) {
      var parent = el.parentElement;
      var link = document.createElement('a');
      link.className = (el.className || 'link link--text list-menu__item list-menu__item--link').replace('snl-ketch-pending', '').trim();
      var elStyle = (el.getAttribute('style') || '').replace(/visibility\s*:\s*hidden\s*;?/gi, '').trim();
      if (elStyle) link.setAttribute('style', elStyle);
      link.id = 'preferenceCenterLink';
      link.href = '#';
      link.setAttribute('onclick', "ketch('showPreferences')");
      link.innerHTML = '<img alt="Preferences" src="https://bit.ly/48YCwmT" width="25" height="12"> Your privacy choices';
      parent.replaceChild(link, el);
    }
  });

  // Remove empty anchor tags left by browser splitting invalid nested <a> elements
  document.querySelectorAll('a').forEach(function (el) {
    if (!el.textContent.trim() && !el.children.length && el !== document.activeElement) {
      el.remove();
    }
  });
});
